import { PUBLIC_MODULES } from '../config/publicModules';
import { GUEST_SECTION_DEFAULTS } from '../config/guestSection';
import { INFO_CARDS_DEFAULTS } from '../config/infoCards';

const LEGACY_KEYS = {
  gallery: 'enable_gallery',
  gifts: 'enable_gifts',
  accommodation: 'enable_airbnb',
};

/** @returns {boolean} */
export function isModuleEnabled(settings, moduleId) {
  if (!settings) return true;

  const def = PUBLIC_MODULES.find((m) => m.id === moduleId);
  const key = def?.settingKey || `module_${moduleId}_visible`;
  const raw = settings[key];

  if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
    const v = String(raw).trim().toLowerCase();
    if (v === '0' || v === 'false' || v === 'no' || v === 'off') return false;
    return v === '1' || v === 'true' || raw === true;
  }

  const legacyKey = LEGACY_KEYS[moduleId];
  if (legacyKey && settings[legacyKey] !== undefined && settings[legacyKey] !== null) {
    return String(settings[legacyKey]) === '1';
  }

  return true;
}

/** Default settings object with all modules on (for admin initial state). */
export function defaultModuleSettings() {
  const out = {};
  PUBLIC_MODULES.forEach((m) => {
    out[m.settingKey] = '1';
  });
  out.guest_section_title = GUEST_SECTION_DEFAULTS.guest_section_title;
  out.guest_section_body = GUEST_SECTION_DEFAULTS.guest_section_body;
  Object.assign(out, INFO_CARDS_DEFAULTS);
  out.enable_gallery = '1';
  out.enable_gifts = '1';
  out.enable_airbnb = '1';
  return out;
}
